import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
export type Ad_Targeting_FragmentFragment = {
    __typename?: 'AdTargeting';
} & Pick<
    Types.AdTargeting,
    | 'activity'
    | 'areaName'
    | 'bedsMax'
    | 'bedsMin'
    | 'brand'
    | 'brandPrimary'
    | 'countyAreaName'
    | 'countryCode'
    | 'currencyCode'
    | 'listingsCategory'
    | 'outcode'
    | 'outcodes'
    | 'page'
    | 'postalArea'
    | 'priceMax'
    | 'priceMin'
    | 'propertyType'
    | 'regionName'
    | 'resultsSort'
    | 'searchLocation'
    | 'searchResultsCount'
    | 'section'
    | 'totalResults'
    | 'url'
    | 'viewType'
>;

export const Ad_Targeting_FragmentFragmentDoc = gql`
    fragment AD_TARGETING_FRAGMENT on AdTargeting {
        activity
        areaName
        bedsMax
        bedsMin
        brand
        brandPrimary
        countyAreaName
        countryCode
        currencyCode
        listingsCategory
        outcode
        outcodes
        page
        postalArea
        priceMax
        priceMin
        propertyType
        regionName
        resultsSort
        searchLocation
        searchResultsCount
        section
        totalResults
        url
        viewType
    }
`;
